import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { CrudService } from "src/app/components/shared/cruds/crud.service";

@Injectable({ providedIn: "root" })
export class TipoMaterialesService extends CrudService<any>{
  protected controller: string = 'settings/tiposmateriales/';

  public addWithFile(defa: any, imagen:File): Observable<any> {
    const options = {
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
    };
    const formData = new FormData();
    Object.keys(defa).forEach((v)=> formData.append(v, defa[v]));

    if (imagen) {
      formData.append("Imagen", imagen, "Imagen");
    }
    return this.http.post<any>(
      `${environment.serverUrl}api/settings/tiposmateriales/addWithImage`,
      formData
    );
  }

  public updateWithFile(defa: any, imagen:File): Observable<any> {
    const formData = new FormData();
    Object.keys(defa).forEach((v)=> formData.append(v, defa[v]));

    if (imagen) {
      formData.append("Imagen", imagen, "Imagen");
    }
    return this.http.post<any>(
      `${environment.serverUrl}api/settings/tiposmateriales/updateWithImage`,
      formData
    );
  }

  
  public image(i: string ): Observable<string> {
    return this.http.get<string>(
      `${environment.serverUrl}api/${this.controller}image`,
      { params: { i } }
    );
  }
}
